import React, { FunctionComponent } from 'react';

import SettingsPanelBase from '../SettingsPanelBase';

// TODO: actually make a spinner/loading message...
const LoadingSpinnerPanel: FunctionComponent<{}> = () => <SettingsPanelBase />;

export default LoadingSpinnerPanel;
